import { fokaAxios } from 'app/fokaAxios'

const { get } = fokaAxios
export default {
  getTrackerCampaigns: ({ trackId, page = 0, limit = 10 }) =>
    get(`/api/v2/trackers/${trackId}/campaigns`, {
      params: {
        page,
        limit,
      },
    }),
  getTrackerAdGroups: ({ trackId, page = 0, limit = 10 }) =>
    get(`/api/v2/trackers/${trackId}/adgroups`, {
      params: {
        page,
        limit,
      },
    }),
}
